import { configureStore } from "@reduxjs/toolkit";
import campaignReducer from "./slices/campaign.slice";
import catalogueReducer from "./slices/catalogue.slice";
import clientReducer from "./slices/client.slice";
import eventReducer from "./slices/event.slice";
import nodeReducer from "./slices/node.slice";
import personaReducer from "./slices/persona.slice";
import templateReducer from "./slices/template.slice";
import toolsReducer from "./slices/tools.slice";
// import authReducer from "./slices/auth.slice";

const store = configureStore({
    reducer: {
        nodeData: nodeReducer,
        tools: toolsReducer,
        persona: personaReducer,
        template: templateReducer,
        campaign: campaignReducer,
        client: clientReducer,
        catalogue: catalogueReducer,
        event: eventReducer
        // auth: authReducer,
    }
});

export default store;
